module.exports = __webpack_public_path__ + "media/Chapter1VoiceOver.20fa8d03.mp3";